<template>
    <div class="GameResult">
        <mNav :msg="msg" :IsHome="true" :isActive="2"></mNav>
        <div class="nav_qie">
            <h3 :style="{'color':'#3277BC','text-align':'left'}">{{$t('message.Resut.title')}}</h3>
            <!-- <van-row type="flex" justify="space-around">
                <van-col span="6">
                    <van-button type="info" plain size="mini" color="#3277BC" @click="handleLiveResult">实时成绩</van-button>
                </van-col>
                <van-col span="6">
                    <van-button type="info" plain size="mini" color="#3277BC" @click="handleGameResult">赛事成绩</van-button>
                </van-col>
            </van-row> -->
        </div>
        <div>
            <van-tabs v-model="active" swipeable @click="onClick"
             type="card" :border="true" 
              color="#3277BC"
               background="#fffff"
               title-active-color="white"
               :ellipsis="false"
               >
               <!-- :sticky="true"
               offset-top="46px" -->

               <!-- 时间筛选条件 -->
                <div class="search_box">
                    <div class="conds">
                        <div class="conds_time">
                            <span :style="{'width':'1.5rem','display':'inline-block','text-align':'center'}">{{$t('message.Resut.session')+'：'}}</span>
                            <!-- <input type="text" v-model="SearchCond.StartTime" @click="showPicker = true" readonly placeholder="开始时间"> -->
                            <el-select v-model="SearchCond.SessionVal" :placeholder="$t('message.Resut.sessionAll')" clearable  size="small" :style="{'width':'3rem'}"  @change="selectChange">
                                <el-option
                                v-for="item in options"
                                :key="item.SessionNumber"
                                :label="item.SessionDes + ' ' + item.SessionTime"
                                :value="item.SessionTime">
                                </el-option>
                            </el-select>
                            <!-- <span class="zhi el-icon-sort-up"></span>
                            <input type="text" v-model="SearchCond.EndTime" @click="showPicker_endtime = true" readonly placeholder="结束时间"> -->
                        </div>
                        <div class="conds_others">
                            <span class="iconfont icon-shaixuan" :style="{'font-size': '0.36rem'}" @click="show=true"></span>
                            <van-popup v-model="show" position="top" 
                                :get-container="getContainer"
                                :style="{  'width': '100%','min-height': '30%' }" 
                                >
                                <div class="search_box_one">
                                    <!-- <div class="search_top">
                                        <div class="top_txt">单元&时间</div>
                                        <div class="top_input conds_time">
                                            <input type="text" v-model="SearchCond.StartTime" @click="showPicker = true" readonly placeholder="开始时间">
                                            <span class="zhi el-icon-sort-up"></span>
                                            <input type="text" v-model="SearchCond.EndTime" @click="showPicker_endtime = true" readonly placeholder="结束时间">
                                        </div>
                                    </div> -->
                                    <div class="search_top">
                                        <div class="top_txt">{{$t('message.SearchCond.SearchAth')}}</div>
                                        <div class="top_input">
                                            <input type="text" class="input_box" v-model="SearchCond.athlete" :placeholder="$t('message.SearchCond.SearchAthTips')">
                                        </div>
                                    </div>
                                    <div class="search_top">
                                        <div class="top_txt">{{$t('message.SearchCond.Court')}}</div>
                                        <div class="top_input" style="height: auto;">
                                            <!-- <input type="text" class="input_box" readonly  @click="aaaa" v-model="result" /> -->
                                            <el-select v-model="SearchCond.CourtNum" multiple :placeholder="$t('message.SearchCond.CourtTips')"
                                            :style="{'width':'70%'}"
                                             :popper-append-to-body="false" >
                                                <!-- <el-option label="全部" value="-1"></el-option> -->
                                                <el-option
                                                v-for="item in 13"
                                                :key="item"
                                                :label="item"
                                                :value="item">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                    <div class="search_top">
                                        <div class="top_txt">{{$t('message.SearchCond.Status')}}</div>
                                        <div class="top_input" style="height: auto;">
                                            <!-- <input type="text" class="input_box" readonly  @click="aaaa" v-model="result" /> -->
                                            <el-select v-model="SearchCond.F_MatchStatusID" multiple :placeholder="$t('message.Resut.sessionAll')"
                                            :style="{'width':'70%'}" :popper-append-to-body="false" >
                                                <!-- <el-option label="全部" value="-1"></el-option> -->
                                                <el-option
                                                v-for="item in StatusList"
                                                :key="item.ID"
                                                :label="$i18n.locale == 'ENG' ? item.code : item.name"
                                                :value="item.ID">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                    <div class="search_btn">
                                        <el-button class="btn" icon="el-icon-search" 
                                        type="text" size="small"
                                        @click="search_btn">{{$t('message.SearchCond.SearchBtn')}}</el-button>
                                    </div>
                                </div>
                            </van-popup>
                        </div>
                    </div>
                    
                </div>
                <!-- <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
                    > -->
                <!-- 内容列表部分 -->
                <div v-if="polyList.length > 0">
                    <van-tab v-for="(item,index) in polyList" :title="item.date" :key="index">
                        <div class="list_game" v-if="item.list.length > 0">
                            <van-collapse v-model="activeNames" v-for="(i,indexs) in item.list" :key="indexs" 
                            :style="{'border':'1px solid #3277BC','margin-top':'0.15rem','border-radius':'0.1rem'}">
                            <!-- <el-card> -->
                                <van-collapse-item :name="indexs" :disabled="i.tpId!=3">
                                    <template #title>
                                        <ul class="ll_box" :style="{'padding-bottom':'0.3rem'}">
                                            <!-- 团体 -->
                                            <li class="list_li" :style="{'border':'none'}" v-if="i.tpId==3">
                                                <div class="list_li_top">
                                                    <div class="list_li_time" :class="{ 'start': i.stId <= 40, 'running' : i.stId == 50,
                                                    'end':i.stId >= 100 }">{{i.sTm}}</div>
                                                    <div class="list_li_txt abs">{{i.mn}}</div>
                                                    <div class="list_li_cout">{{i.ctNo}}</div>
                                                </div>
                                                <!-- <div class="list_li_center">
                                                    <div class="list_li_Home">{{i.ANname}}beijng</div>
                                                    <div class="list_li_Home_point">【{{i.MatchScoreLeft}}2】{{i.SetScoreLeft}}3</div>
                                                    <div class="list_li_txt_1">VS</div>
                                                    <div class="list_li_Home_point">{{i.SetScoreRight}}2【{{i.MatchScoreRight4}}1】</div>
                                                    <div class="list_li_Away"> {{i.BName}}zhangsan</div>
                                                </div> -->
                                                <div class="list_li_btm">
                                                    <div class="team_name" :class="{'win':i.wnr == 'A'}">
                                                        <p>{{i.dgNmA}}</p>
                                                        <p></p>
                                                    </div>
                                                    <div class="CurrentScore">
                                                        <span>{{i.msL}}</span>
                                                    </div>
                                                    <div class="when_time">
                                                        VS
                                                    </div>
                                                    <div class="CurrentScore">
                                                        <span>{{i.msR}}</span>
                                                    </div>
                                                    <div class="team_name" :class="{'win':i.wnr == 'B'}">
                                                        <p>{{i.dgNmB}}</p>
                                                        <!-- <p>王六</p> -->
                                                    </div>
                                                </div>
                                                <div class="when_time" :style="{'color': '#3277BC'}">
                                                    {{i.dur}}
                                                </div>
                                                <!-- <div class="set_score" :style="{'width':'auto','background':'none'}">
                                                    11-3,11-4,11-6,5-11,6-22,4-22,4-22,5-66
                                                </div> -->
                                                
                                            </li>
                                            <!-- 个人 -->
                                            <li class="list_li" :style="{'border':'none'}" v-if="i.tpId!=3">
                                                <div class="list_li_top">
                                                    <div class="list_li_time" :class="{ 'start': i.stId <= 40, 'running' : i.stId == 50,
                                                    'end':i.stId >= 100 }">{{i.sTm}}</div>
                                                    <div class="list_li_txt abs">{{i.mn}}</div>
                                                    <div class="list_li_cout">{{i.ctNo}}</div>
                                                </div>
                                                <div class="list_li_center">
                                                    <div class="list_li_Home" :class="{'win':i.wnr == 'A'}">{{i.dgNmA}}</div>
                                                    <div class="list_li_Home_point"><span v-if="i.stId >40">【</span>{{i.msL}}<span v-if="i.stId >40">】</span></div>
                                                    <div class="list_li_txt_1">VS</div>
                                                    <div class="list_li_Home_point"><span v-if="i.stId >40">【</span>{{i.msR}}<span v-if="i.stId >40">】</span></div>
                                                    <div class="list_li_Away" :class="{'win':i.wnr == 'B'}"> {{i.dgNmB}}</div>
                                                </div>
                                                <div class="list_li_btm">
                                                    <div class="team_name" :class="{'win':i.wnr == 'A'}">
                                                        <p>{{i.Results[0].pA1}}</p>
                                                        <p :class="{'border-top': i.Results[0].pA2}">{{i.Results[0].pA2}}</p>
                                                        <p :style="{'line-height':'normal','font-size':'0.24rem'}" v-if="i.plA">({{ i.plA }})</p>
                                                    </div>
                                                    <div class="CurrentScore">
                                                        <span>{{i.csL}}</span>
                                                    </div>
                                                    <div class="when_time">
                                                        {{i.dur}}
                                                    </div>
                                                    <div class="CurrentScore">
                                                        <span>{{i.csR}}</span>
                                                    </div>
                                                    <div class="team_name" :class="{'win':i.wnr == 'B'}">
                                                        <p>{{i.Results[0].pB1}}</p>
                                                        <p :class="{'border-top': i.Results[0].pB2}">{{i.Results[0].pB2}}</p>
                                                        <p :style="{'line-height':'normal','font-size':'0.24rem'}" v-if="i.plB">({{ i.plB }})</p>
                                                    </div>
                                                </div>
                                                <div class="set_score" :style="{'width':'auto','background':'none'}">
                                                    <span v-if="i.Results[0].A1 != undefined">{{ i.Results[0].A1 +'-' + i.Results[0].B1}}<i v-if="i.Results[0].A2 != undefined">,</i></span>
                                                    <span v-if="i.Results[0].A2 != undefined">{{ i.Results[0].A2 +'-' + i.Results[0].B2}}<i v-if="i.Results[0].A3 != undefined">,</i></span>
                                                    <span v-if="i.Results[0].A3 != undefined">{{ i.Results[0].A3 +'-' + i.Results[0].B3}}<i v-if="i.Results[0].A4 != undefined">,</i></span>
                                                    <span v-if="i.Results[0].A4 != undefined">{{ i.Results[0].A4 +'-' + i.Results[0].B4}}<i v-if="i.Results[0].A5 != undefined">,</i></span>
                                                    <span v-if="i.Results[0].A5 != undefined">{{ i.Results[0].A5 +'-' + i.Results[0].B5}}<i v-if="i.Results[0].A6 != undefined">,</i></span>
                                                    <span v-if="i.Results[0].A6 != undefined">{{ i.Results[0].A6 +'-' + i.Results[0].B6}}<i v-if="i.Results[0].A7 != undefined">,</i></span>
                                                    <span v-if="i.Results[0].A7 != undefined">{{ i.Results[0].A7 +'-' + i.Results[0].B7}}</span>
                                                    <div :style="{'font-size':'0.2rem'}" v-if="i.Results[0].A1 != undefined">
                                                        <p v-if="i.Results[0].upN && i.Results[0].upN != ''">{{$t('message.Resut.umpire')}}：{{i.Results[0].upN}}</p>
                                                        <!-- <p v-if="i.Results[0].svN && i.Results[0].svN != ''" :style="{'margin-left':'0.2rem'}">{{$t('message.Resut.serverUmpire')}}：{{i.Results[0].svN}}</p> -->
                                                        <p v-if="i.Results[0].svN && i.Results[0].svN != ''" >{{$t('message.Resut.serverUmpire')}}：{{i.Results[0].svN}}</p>
                                                    </div>
                                                </div>
                                                
                                            </li>
                                        </ul>
                                        <!-- <div>标题1 <van-icon name="question-o" /></div>
                                        <div>标题1 <van-icon name="question-o" /></div>
                                        <div>标题1 <van-icon name="question-o" /></div> -->
                                    </template>
                                    
                                    <template>
                                        <ul class="ll_box" :style="{'background':'rgba(50,119,188,1)'}">
                                            <li class="list_li" v-for="(j,index) in i.Results" :key="index"
                                            :style="{'border':'none','border-bottom':'1px solid white','border-radius':'0','margin':'0','color':'white'}"
                                            >
                                                <div class="list_li_top">
                                                    <div v-if="$i18n.locale == 'CHN'">第{{j.sNo}}场</div>
                                                    <div v-else>Match {{j.sNo}}</div>
                                                    <!-- <div class="list_li_txt abs">{{i.MatchName}}男子团体第{{index+1}}场</div>
                                                    <div class="list_li_cout">{{i.CourtNum}}3</div> -->
                                                </div>
                                                <div class="list_li_btm" :style="{'margin':'0'}">
                                                    <div class="team_name" :class="{'win':j.wnr == 'A'}">
                                                        <p>{{j.pA1}}</p>
                                                        <p>{{j.pA2}}</p>
                                                        <p :style="{'line-height':'normal','font-size':'0.24rem'}" v-if="j.ptA">({{ j.ptA }})</p>
                                                    </div>
                                                    <div class="CurrentScore" :style="{'font-size':' 0.4rem'}">
                                                        <span>{{j.ssL}}</span>
                                                    </div>
                                                    <div class="when_time" :style="{'color':' white'}">
                                                        <!-- {{i.Duration}} -->
                                                        VS
                                                    </div>
                                                    
                                                    <div class="CurrentScore" :style="{'font-size':' 0.4rem'}">
                                                        <span>{{j.ssR}}</span>
                                                    </div>
                                                    <div class="team_name" :class="{'win':j.wnr == 'B'}">
                                                        <p>{{j.pB1}}</p>
                                                        <p>{{j.pB2}}</p>
                                                        <p :style="{'line-height':'normal','font-size':'0.24rem'}" v-if="j.ptB">({{ j.ptB }})</p>
                                                    </div>
                                                </div>
                                                <div class="when_time" v-if="j.dur">
                                                        {{j.dur}}min
                                                </div>
                                                <div class="set_score" :style="{'width':'auto','background':'none','margin':'0'}">
                                                    <span v-if="j.A1 != undefined">{{ j.A1 +'-' + j.B1}}<i v-if="j.A2 != undefined">,</i></span>
                                                    <span v-if="j.A2 != undefined">{{ j.A2 +'-' + j.B2}}<i v-if="j.A3 != undefined">,</i></span>
                                                    <span v-if="j.A3 != undefined">{{ j.A3 +'-' + j.B3}}<i v-if="j.A4 != undefined">,</i></span>
                                                    <span v-if="j.A4 != undefined">{{ j.A4 +'-' + j.B4}}<i v-if="j.A5 != undefined">,</i></span>
                                                    <span v-if="j.A5 != undefined">{{ j.A5 +'-' + j.B5}}<i v-if="j.A6 != undefined">,</i></span>
                                                    <span v-if="j.A6 != undefined">{{ j.A6 +'-' + j.B6}}<i v-if="j.A7 != undefined">,</i></span>
                                                    <span v-if="j.A7 != undefined">{{ j.A7 +'-' + j.B7}}</span>
                                                    <div :style="{'font-size':'0.2rem'}" v-if="j.A1 != undefined">
                                                        <span v-if="j.upN && j.upN != ''">{{$t('message.Resut.umpire')}}：{{j.upN}}</span>
                                                        <span v-if="j.svN && j.svN != ''" :style="{'margin-left':'0.2rem'}">{{$t('message.Resut.serverUmpire')}}：{{j.svN}}</span>
                                                    </div>
                                                </div>
                                                
                                            </li>
                                        </ul>
                                    </template>

                                    <template  #right-icon >
                                        <div class="icons" ><i v-if="i.tpId == 3" class="van-icon van-icon-arrow van-cell__right-icon"></i></div>
                                    </template>
                                </van-collapse-item>
                            <!-- </el-card> -->
                            </van-collapse>
                        
                        </div>
                        <van-empty v-else :description="$t('message.Resut.description1')" />
                    </van-tab>
                </div>
                <van-empty v-else :description="$t('message.Resut.description2')" />

                <!-- </van-list> -->
            </van-tabs>
        </div>



        <!-- <van-popup v-model="showPicker" position="bottom">
            <van-datetime-picker
                type="time"
                @confirm="startConfirm"
                @cancel="startCancle"
                cancel-button-text="清空"
            />
        </van-popup> -->

        <!-- <van-popup v-model="showPicker_endtime" position="bottom">
            <van-datetime-picker
                type="time"
                @confirm="endConfirm"
                @cancel="endCancle"
                cancel-button-text="清空"
            />
        </van-popup> -->

    </div>
</template>

<script>
import http from '@/assets/js/http.js';
import mNav from "@/components/mNav.vue";
import LiveList from '@/assets/common/ResultList.json';
import { Lazyload,Toast,Dialog } from "vant";
export default {
    name:'GameResult',
    components: {
        mNav,
    },
    data() {
        return {
            msg: sessionStorage.SportName,
            active: 0,
            value: '',
            showPicker: false,
            showPicker_endtime: false,
            switch1:'',
            switch2:'',
            show: false,
            SearchCond: {
                StartTime:'',
                EndTime:'',
                SessionVal:'',
                CourtNum: [],
                athlete:'',
                F_MatchStatusID:[],
            },
            StatusList:[
                // {
                //     name: '全部',
                //     ID: 1,
                //     code: 'all'
                // },
                {
                    name: '未开始',
                    code: 'Schedule',
                    ID: 40,
                },
                {
                    name: '进行中',
                    code: 'Running',
                    ID: 50,
                    
                },
                {
                    name: '已结束',
                    code: 'Official',
                    ID: 100,
                }
            ],
            resetSearchCond: {
                StartTime:'',
                EndTime:'',
                SessionVal:'',
                CourtNum: [],
                athlete:'',
                F_MatchStatusID:[],
            },
            activeNames: [],
            list:[],
            loading: false,
            finished: false,
            PageIndex: 1,
            PageCount: 10,
            totleNum: 0,
            GameList: [],
            searchList:[],
            allGameList:[],
            polyList:[],
            timer: null,
            SessionOptions: [],
            options: [],
            
        }
    },
    watch: {
        // 监听路由对象中的变化
        '$route': {
            handler: function (to, from) {
                // 当你想要弹出对话框的条件
                if (!sessionStorage.SportCode) {
                // 调用弹框的方法，这里以 alert 为例
                // alert('你要弹框的内容');用的 Loading 需要异步关闭
                    setTimeout(() =>{
                        Dialog.close();
                    },100)
                }
            },
            // 如果需要在页面首次加载时也检查条件，设置 immediate: true
            immediate: true
        }
    },
    mounted() {
        let nowTime = this.dateTransfor(new Date(), 'yyyy-MM-dd');
        this.PageIndex = 1;
        let randomNum = Math.random(); // 这里的范围根据需求进行调整
        
        if(!(sessionStorage.SportCode && sessionStorage.SportName)){
            this.$router.push({
                path: '/mHome', 
                query: { v: randomNum }
            });
        }
        this.UpdataLang();//设置语言
        // setTimeout(()=>{
        //获取赛事时间地址
        http.GetFile('/Sports/BDM/'+sessionStorage.SportCode+'/MatchDate.json?v='+Math.random()).then(res=>{
            console.log(res)
            this.SessionOptions = res;
            this.options = res.JsonData[this.active].SessionDetail;
            // this.searchCommon();//筛选的方法
            
        })
        // },1000*2)
        http.GetFile('/Sports/BDM/'+sessionStorage.SportCode+'/ResultList.json?v='+Math.random()).then(res=>{//获取赛事列表地址
            console.log(res)
            this.GameList = res;
            this.haspolymerization();//数组聚合,重新整合json数据
            // this.onClick(); 
            // let nowTime = this.dateTransfor(new Date(), 'yyyy-MM-dd');
                // console.log(this.polyList)
            // 判断日期，active在哪块
            for(let i = 0; i < this.polyList.length;i++){
                let item = this.polyList[i];
                // console.log(item.date)
                if(item.date == nowTime){
                    this.active = i;
                    this.options = this.SessionOptions.JsonData[this.active].SessionDetail;
                    return;
                }else if(item.date > nowTime){
                    this.active = 0;
                    this.options = this.SessionOptions.JsonData[this.active].SessionDetail;
                    return;
                }else{
                    this.active = this.polyList.length - 1;
                    this.options = this.SessionOptions.JsonData[this.active].SessionDetail;
                    // console.log(echararr.length-1)
                    // return;
                }
                // console.log(this.active)
            }
            
        })
        setTimeout(()=>{
            console.log(this.polyList[this.active].date)
            if(this.polyList[this.active].date == nowTime){
                console.log(1)
                    this.timer = setInterval(() => {
                        this.getLive();
                    }, 1000*5);
            }else{
                console.log(2)
                // clearInterval(this.timer);
                // this.timer = null;
            }
        },1000*3)
        
        // console.log(this.$route)
        

    },
    beforeDestroy(){
        clearInterval(this.timer);
        this.timer = null;
    },
    computed: {
    },
    methods: {

        getLive(){
            // this.timer = setInterval(() => {
            http.GetFile('/Sports/BDM/'+sessionStorage.SportCode+'/Live.json?v='+Math.random()).then(data=>{//获取赛事列表地址
                // console.log(data)
                // console.log(this.GameList)
                
                // 实时文件与大文件做匹配
                if(data.JsonData && data.JsonData.length > 0){
                    for (let j = 0; j < this.GameList.JsonData.length; j++) {
                        let jItem = this.GameList.JsonData[j];
                        for (let i = 0; i < data.JsonData.length; i++) {
                            let el = data.JsonData[i];
                            if (el.ssDt == jItem.ssDt && el.mId == jItem.mId) {
                                // console.log(123123123123)
                                // console.log(jItem)
                                // jItem = el;
                                for (const key in el) {
                                    jItem[key] = el[key];
                                }
                                

                            }
                        }
                    }
                    
                    /***
                     * 将两个数组进行比较，如果查找的id有重复值，不做处理，如果没有则添加进去
                     */
                    // combinedArray() {
                        const array1Ids = new Set(this.GameList.JsonData.map(item => item.mId));
                        const newItem = data.JsonData.find(item => !array1Ids.has(item.mId));
                        // console.log(newItem ? [...this.GameList.JsonData, newItem] : this.GameList.JsonData)
                        this.GameList.JsonData = newItem ? [...this.GameList.JsonData, newItem] : this.GameList.JsonData;
                        // this.haspolymerization();//重新聚合数组
                        // this.$nextTick(() => {
                        // DOM现在已经刷新
                            this.searchCommon();//筛选的方法
                        // })
                        
                        // return newItem ? [...this.GameList.JsonData, newItem] : this.GameList.JsonData;
                    // }
                }
            })
            // }, 1000*5);
        },  
        handleGameResult(){//点击赛事成绩c
            // this.$router.push('/GameResult');
        },
        handleLiveResult(){//点击实时成绩
            // 生成随机数
            let randomNum = Math.random(); // 这里的范围根据需求进行调整
            this.$router.push({
                 path: '/Live', 
                 query: { v: randomNum }
            });
        },
        haspolymerization(){//数组聚合,重新整合json数据
            let echararr = [];
            let data = this.GameList.JsonData;
            // this.active = 0;
            // console.log(data)
            /**
             * 将json数据按照日期先整合，重新生成新数组进行页面循环
            */
            data.forEach((el,index) => {
                // console.log(el)
                let arrindex = echararr.findIndex((item,index,arr)=>{
                    return item.date === el.dt;
                })
                if(arrindex==-1){
                    echararr.push({
                        'date': el.dt,
                        'list': [el],
                    })
                }else{
                    echararr[arrindex]['list'].push(el)
                }
            });
            
            echararr.sort((a,b)=>{
                return new Date(a.date) - new Date(b.date);
            })
            // echararr.sort()
        

            console.log(echararr);
            
            
            this.searchList = echararr;
            this.polyList= echararr;
            this.allGameList = echararr;
            
        },
        // 点击日期导航操作
        onClick(name, title){
            
            console.log(name, title);
            // console.log(this.resetSearchCond);
            
            this.activeNames = [];
            this.haspolymerization();//重新聚合数组
            this.SearchCond = JSON.parse(JSON.stringify(this.resetSearchCond));
            let nowTime = this.dateTransfor(new Date(), 'yyyy-MM-dd');
            this.active = name;
            // console.log( this.active);
            // console.log(this.activeNames)
            clearInterval(this.timer);
            this.timer = null;
            for (let i = 0; i < this.SessionOptions.JsonData.length; i++) {
                const el = this.SessionOptions.JsonData[i];
                if (title == el.SessionDate) {
                    // console.log(1111)
                    this.options = el.SessionDetail;
                    // this.$forceUpdate()
                    // return;
                }
            }

            /**
             * 判断点击的日期是否是当前日期，如果是则实时更新，如果不是则不实时更新
             */
            if(title >= nowTime){
                this.timer = setInterval(() => {
                    this.getLive();
                }, 1000*5);
            }else{
                // this.getLive();
                clearInterval(this.timer);
                this.timer = null;
            }
            
        },
        
        onLoad() {
            // 异步更新数据
            // setTimeout 仅做示例，真实场景中一般为 ajax 请求
            // PageIndex: 1,
            // PageCount: 10,
            // totleNum: 0,
            let newArr= [];
            // setTimeout(() => {
            //     for (let i = 0; i < 10; i++) {
            //         this.list.push(this.list.length + 1);
            //     }

            //     // 加载状态结束
            //     this.loading = false;

            //     // 数据全部加载完成
            //     if (this.list.length >= 40) {
            //         this.finished = true;
            //     }
            // }, 1000);
        },
        selectChange(val){//点击单元筛选
            console.log(val)
            // console.log(this.searchList[this.active])
            this.searchCommon();//筛选的方法
            // console.log(this.active)
        },
        startConfirm(time) {//点击开始时间的确认按钮
            console.log(time);
            if(this.SearchCond.EndTime !='' && time  >= this.SearchCond.EndTime){
                Toast({
                    message:'开始时间不能大于或等于结束时间',
                    duration:1000
                });
            }else{
                this.SearchCond.StartTime = time;
                this.showPicker = false;
                if(!this.show){
                    this.searchCommon();//筛选的方法
                }
            }
        },
        startCancle(){//点击开始时间的清空按钮
            this.SearchCond.StartTime = '';
            this.showPicker = false;
            if(!this.show){
                this.searchCommon();//筛选的方法
            }
        },
        endConfirm(time){//点击结束时间弹框的确认按钮
            if(time  <= this.SearchCond.StartTime){
                Toast({
                    message:'结束时间不能小于或等于开始时间',
                    duration:1000
                });
            }else{
                this.SearchCond.EndTime = time;
                this.showPicker_endtime = false;
                if(!this.show){
                    this.searchCommon();//筛选的方法
                }
            }
            
        },
        endCancle(){//点击结束时间弹框的清空按钮
            this.SearchCond.EndTime= '';
            this.showPicker_endtime = false;
            if(!this.show){
                this.searchCommon();//筛选的方法
            }
        },

        onConfirm222() {//筛选下拉确认
            // this.$refs.item.toggle();
            // console.log(this.$refs.item)
        },
         // 返回一个特定的 DOM 节点，作为挂载的父节点
        getContainer() {
            return document.querySelector('.conds_others');
        },
        search_btn(){//点击搜索按钮
            this.searchCommon();//筛选的方法
            this.show = !this.show
            // this.polyList[this.active].list = this.list;
        },
        searchCommon() {//筛选的方法
            let SearchCond = this.SearchCond;
            let newarr = [];
            // console.log(this.active)
            // this.searchList = this.allGameList;
            this.haspolymerization();//重新聚合数组
            // console.log(this.allGameList)
            // console.log(this.active)
            let copyArr = JSON.parse(JSON.stringify(this.searchList[this.active].list))
            console.log(copyArr)
            newarr = copyArr;
            // 存在开始时间判断条件
            if (SearchCond.StartTime) {
                newarr = copyArr.filter(ele => {
                    return ele.sTm >= SearchCond.StartTime
                })
            }
            // 存在结束时间判断条件
            if (SearchCond.EndTime) {
                newarr = newarr.filter(ele => {
                    return ele.sTm <= SearchCond.EndTime
                })
            }

             // 存在单元筛选的判断条件
             if (SearchCond.SessionVal) {
                newarr = newarr.filter(ele => {
                    return ele.ssTm == SearchCond.SessionVal
                })
            }

            // 存在多场地判断条件
            if (SearchCond.CourtNum.length) {
                const arr = []
                newarr.map(ele => {
                    SearchCond.CourtNum.includes( Number(ele.ctNo) ) && arr.push(ele)
                })
                newarr = arr;
            }
            // 存在比赛状态判断条件
            if (SearchCond.F_MatchStatusID.length) {
                const arr = []
                newarr.map(ele => {
                    SearchCond.F_MatchStatusID.includes( Number(ele.stId) ) && arr.push(ele)
                })
                // 单独处理110状态情况
                if (SearchCond.F_MatchStatusID.includes(100)) {
                    newarr.map( ele => {
                        ele.stId == 110 && arr.push(ele)
                    })
                }
                newarr = arr;
            }
            // 存在运动员判断条件
            if (SearchCond.athlete) {
                const arr = []
                newarr.map(ele => {
                    const subArr = []
                    ele.Results.length && ele.Results.map(item => {
                        const key = item['pA1'].indexOf(SearchCond.athlete.toLowerCase()) > -1 || item['pA2'] && item['pA2'].indexOf(SearchCond.athlete.toLowerCase()) > -1 || item['pB1'].indexOf(SearchCond.athlete.toLowerCase()) > -1 || item['pB2'] && item['pB2'].indexOf(SearchCond.athlete.toLowerCase()) > -1
                        key && subArr.push(item)
                    })
                    subArr.length && (ele['Results'] = subArr) && arr.push(ele) 
                })
                newarr = arr;
            }
            console.log(newarr);
            // this.list = newarr;
            return this.polyList[this.active].list = newarr;
            // console.log(this.polyList);
        },
        // 日期格式转换函数
        dateTransfor(date,format){
            var o = {
                "M+" : date.getMonth()+1,                 //月份
                "d+" : date.getDate(),                    //日
                "h+" : date.getHours(),                   //小时
                "m+" : date.getMinutes(),                 //分
                "s+" : date.getSeconds(),                 //秒
                "q+" : Math.floor((date.getMonth()+3)/3), //季度
                "S"  : date.getMilliseconds()             //毫秒
            };
            if(/(y+)/.test(format)) {
                format=format.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
            }
            for(let k in o) {
                if(new RegExp("("+ k +")").test(format)){
                    format = format.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
                }
            }
            return format;
        },
        //设置语言
        UpdataLang() {
            if(sessionStorage.language){
                if(sessionStorage.language == 'ENG'){
                this.$i18n.locale = 'ENG';
                // Locale.use('ENG', enUS)
                // this.$i18n.setLocaleMessage('ENG')
                }else{
                    this.$i18n.locale = 'CHN';
                // Locale.use('CHN', zhCN)
                // this.$i18n.setLocaleMessage('CHN')
                }
            }else{
                this.$i18n.locale = 'CHN';
                // Locale.use('CHN', zhCN) 
            }
            
        },

    },
}
</script>

<style lang="scss" scoped>
    $bgColor: #3277BC;  
    .start{
        background: white;
        color: black;
        border: 1px solid #3277BC;
    }
    .running{
        background: green;
        color: white;
        border: 1px solid green;
    }
    .end{
        background: $bgColor;
        color: white;
        border: 1px solid $bgColor;
    }
    .win{
        font-weight: bold;
        // background: #3277BC;
    }
    ::v-deep .van-tabs__nav--card{
        margin: 0;
    }
    ::v-deep .van-cell{
        padding: 0.1rem;
    }
    ::v-deep .van-collapse-item__content{
        padding: 0.1rem;
    }
    ::v-deep .van-cell__right-icon{
        display: block;
    }
    ::v-deep .van-tabs--card>.van-tabs__wrap{
        height: 40px;
    }
    ::v-deep .van-tabs__nav--card{
        height: 40px;
    }
    // ::v-deep .van-collapse{
    //     box-shadow: 0px 5px 5px #888888;
    // }
    ::v-deep .van-collapse-item__title--disabled, .van-collapse-item__title--disabled .van-cell__right-icon{
        color: #333;
        border-radius: 0.1rem;
    }
    .GameResult{
        font-size: 0.24rem;
    }
    .nav_qie{
        font-size: 0.3rem;
        line-height: 0.3rem;
        text-align: center;
        padding: 0.15rem 0.8rem;
    }
    .conds{
        display: flex;
        padding: 0.1rem;
        background: white;
        font-size: 0.26rem;
        .conds_time{
            width: 90%;
            span{
                line-height: 0.44rem;
                // margin-right: 0.2rem;
            }
            .zhi{
                transform: rotate(90deg) scaleX(-1); 
                // transform: ;
                text-align: center;
                margin-left: 0.2rem;
            }
            input{
                width: 30%;
                margin-left: 0.2rem;
                border: none;
                line-height: 0.4rem;
                text-align: center;
                border-bottom: 1px solid $bgColor;
            }
        }
        .conds_others{
            width: 10%;
            text-align: center;
            line-height: 0.44rem;
            font-size: 0.26rem;
            position: relative;
            .search_box_one{
                padding: 0.4rem;
                font-size: .24rem;
                .search_top{
                    // padding: 0 3%;
                    display: flex;
                    margin-top: 0.2rem;
                    justify-content:space-between;
                    align-items: center;
                    .top_txt{
                        width: 1.2rem;
                        line-height: 0.5rem;
                        text-align: right;
                        text-align: right;
                        margin-right: .2rem;
                    }
                    .top_input{
                        flex: 1;
                        height: 0.5rem;
                        padding-left: .05rem;
                        // border-radius: .04rem;
                        // overflow: hidden;
                    }
                    .input_box{
                        width: 70%;
                        height: 0.5rem;
                        font-size: 0.24rem;
                        border: 1px solid #dadada;
                        // margin-left: 10%;
                        border-radius: 0.04rem;
                        text-indent: 0.14rem;
                    }
                }
            }
            .search_btn{
                width: 100%;
                text-align: center;
                margin-top: 0.3rem;
                background: $bgColor;
                
                .btn{
                    width: 80%;
                    color: white;
                }
            }
            
        }
    }

    .list_game{
        padding: 0.1rem 0.2rem 0.5rem 0.2rem;
    }
    .ll_box{
        width: 100%;
        .list_li{
            padding: 0.1rem;
            border: 1px solid $bgColor;
            border-radius: 0.1rem;
            font-size: 0.2rem;
            text-align: center;
            // margin-bottom: 0.1rem;
            .list_li_top{
                width: 100%;
                display: flex;
                position: relative;
                .list_li_time{
                    width: 15%;
                    height: 0.5rem;
                    // background: rgb(255, 136, 3);
                    // border: 1px solid $bgColor;
                    border-radius: 0.5rem;
                    font-weight: bold;
                    line-height: 0.5rem;
                }
                .list_li_txt{
                    flex: 1;
                    font-weight: bold;
                    line-height: 0.5rem;
                    font-size: 0.3rem;
                    white-space: wrap;
                }
                .list_li_cout{
                    width: 0.5rem;
                    height: 0.5rem;
                    font-size: 0.36rem;
                    border-radius: 50%;
                    background: $bgColor;
                    font-weight: bold;
                    line-height: 0.5rem;
                    color: white;
                    position: absolute;
                    // left: 0;
                    right: 0;
                }
                .abs{
                    position: absolute;
                    left: 15%;
                    right: 0.5rem;
                }
            }
            .list_li_center{
                width: 100%;
                display: flex;
                font-size: 0.3rem;
                margin-top: 0.15rem;
                .list_li_Home{
                    width: 30%;
                    // height: 0.5rem;
                    // background: rgb(255, 136, 3);
                    // border-radius: 0.5rem;
                    line-height: 0.5rem;
                    // white-space: nowrap; /* 不换行 */
                    // overflow: hidden; /* 溢出部分隐藏 */
                    // text-overflow: ellipsis; /* 显示省略号 */
                }
                .list_li_Home_point{
                    width: 19%;
                }
                .list_li_txt_1{
                    width: 14%;
                    line-height: 0.5rem;
                }
                .list_li_Away{
                    width: 30%;
                    // height: 0.5rem;
                    // border-radius: 50%;
                    // background: rgb(165, 58, 58);
                    line-height: 0.5rem;
                    // white-space: nowrap; /* 不换行 */
                    // overflow: hidden; /* 溢出部分隐藏 */
                    // text-overflow: ellipsis; /* 显示省略号 */
                }
            }
            .list_li_btm{
                width: 100%;
                display: flex;
                font-size: 0.3rem;
                justify-items: center;
                align-items: center;
                margin-top: 0.15rem;
                .team_name{
                    width: 25%;
                    p{
                        width: 100%;
                        white-space: wrap;
                        word-wrap: break-word; /* 允许在长单词或URL内部进行换行 */
                        overflow-wrap: break-word; /* 同上，是word-wrap的现代替代 */
                    //     white-space: nowrap; /* 不换行 */
                    //     overflow: hidden; /* 溢出部分隐藏 */
                    //     text-overflow: ellipsis; /* 显示省略号 */
                    }
                }
                .CurrentScore{
                    width: 18%;
                    font-size: 0.6rem;
                }
                .when_time{
                    width: 14%;
                    margin: 0.08rem auto;
                    line-height: 0.35rem;
                    // background: #3277BC;
                    color: $bgColor;
                    align-self: flex-end;
                    font-size: 0.24rem;
                    font-weight: bold;
                }
            }
            .set_score{
                margin-top: 0.15rem;
                font-size: 0.26rem;
                position: relative;
            }
            
        }
    }
    .icons{
        position: absolute;
        left: 50%;
        bottom: 0px;
        transform: translateX(-50%);
        margin-top: 10px;
    }
    .border-top{
        border-top: 1px solid #888;
    }
</style>